// Shared reusable UI primitives for module dashboards.
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function PageHeader({ kicker, title, description, actions }) {
  return (
    <header className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
      <div>
        {kicker && <p className="text-xs uppercase tracking-[0.3em] text-amber-400/70 mb-2">{kicker}</p>}
        <h1 className="text-3xl font-display gold-text">{title}</h1>
        {description && <p className="text-muted-foreground mt-1">{description}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </header>
  );
}

export function KpiCard({ icon, label, value, accent = "text-amber-300", testid, loading }) {
  return (
    <div className="panel-3d-sm rounded-xl p-4 relative z-10" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <div className={`w-9 h-9 rounded-lg bg-black/40 flex items-center justify-center ${accent}`}>{icon}</div>
      </div>
      <p className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
      <p className={`text-2xl font-display mt-1 ${accent}`}>{loading ? "…" : value}</p>
    </div>
  );
}

export function Panel({ title, action, children, className = "" }) {
  return (
    <Card className={`panel-3d border-0 ${className}`}>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-base font-display gold-text">{title}</CardTitle>
          {action}
        </div>
      </CardHeader>
      <CardContent className="relative z-10">{children}</CardContent>
    </Card>
  );
}

export function EmptyState({ icon, message, action }) {
  return (
    <div className="text-center py-12">
      <div className="w-12 h-12 mx-auto text-amber-500/30 mb-3 flex items-center justify-center">{icon}</div>
      <p className="text-muted-foreground mb-4">{message}</p>
      {action}
    </div>
  );
}

export const formatEur = (n) =>
  new Intl.NumberFormat("fi-FI", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const formatNum = (n, digits = 0) =>
  new Intl.NumberFormat("fi-FI", { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(Number(n || 0));
